// noinspection HtmlUnknownAnchorTarget
const KakaoIndex = () => (
  <div id="kakaoIndex">
    <a href="#kakaoBody">본문 바로가기</a>
    <a href="#kakaoGnb">메뉴 바로가기</a>
  </div>
)
export default KakaoIndex
